<app-modal (dismiss)="reset()">
    <ng-container modal-header>
        <p>{{ 'service.tickets.modal.title' | translate }}</p>
    </ng-container>
    <div class="body" modal-body>
        <app-alert type="info" message="{{ computeTitle() }}"></app-alert>
        <form [formGroup]="positionForm" class="form">
            <app-listbox
                [isMaterial]="false"
                [editMode]="true"
                [multiple]="false"
                [selectable]="true"
                displayField="label"
                [formControl]="positionForm.controls['position']"
                [items]="mapSlots(positions)">
            </app-listbox>
            <app-input-switch *ngIf="canBeMarkedAsSpare()"
                              onLabel="{{'generic.yes' | translate}}"
                              offLabel="{{'generic.no' | translate}}"
                              [formControl]="positionForm.controls['spare']"
                              topLabel="{{'service.tickets.details.display.markSpare' | translate}}">
            </app-input-switch>
        </form>
    </div>
    <div class="footer" modal-footer>
        <app-button type="primary"
                    *ngIf="showResetButton()"
                    (clicked)="onResetPosition()">{{ 'generic.buttons.reset' | translate }}
        </app-button>
        <app-button
            *ngIf="showAssignButton()"
            type="primary"
            [disabled]="!this.positionForm.valid"
            (clicked)="onConfirm()">{{ 'Assign' | translate }}
        </app-button>
    </div>
</app-modal>
